'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));

    if (window.resources.preferences.subscriptionProvider == 'ordergroove' && window.OG) {
        processInclude(require('orderGroove/product/detail'));
    }
});
